// src/hooks/programs/useCloseProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { closeProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useCloseProgram = () => {
    const queryClient = useQueryClient();

    const {
        mutate: closeProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, data }) => closeProgram(id, data),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
            queryClient.invalidateQueries({ queryKey: ["program"] });
        },
        onError: (error, variables, context) => {
            if (error.response?.status === 409 && error.response?.data?.code === 'missing_job_orders') {
                // Return error to be handled by onSettled or mutate's onError callback locally
                return;
            }
            const message = parseError(error);
            toast.error(message || "Failed to close program");
        },
    });

    return {
        closeProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useCloseProgram;